<template>
  <div>
    <div class="bg-white p-4 rounded-md">
      <p class="font-bold text-xl pb-2 tracking-tight text-gray-900">
        {{ $t("Prices") }}
      </p>

      <p class="text-red-500" v-if="!productIsInsurable">
        {{ $t("There are no contracts available at this price.") }}
      </p>

      <div v-else-if="this.contracts.length > 0 || this.monthlyPrice">
        <div v-if="this.contracts.length > 0">
          <div v-for="(contract, idx) in sortedContractsByTermLength" :key="idx">
            <div class="flex justify-between">
              <div v-if="contract.monthly" class="font-medium text-sm">
                {{ $t("Monthly") }}
              </div>
              <div v-else-if="contract.recurring" class="font-medium text-sm">
                {{ $t("Annually") }}
              </div>
              <div v-else class="font-medium text-sm">
                {{ formatDuration(contract.termLength) }}
              </div>
              <div>
                {{ formatPrice(contract.price) }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <p class="text-gray-500 text-sm" v-if="!productCategoryValue">
        {{ $t("Select an insurance plan.") }}
      </p>

      <p class="text-gray-500 text-sm" v-if="productRequired && productCategoryValue && !isPresent(price)">
        {{ $t("Enter the price of the product to be insured.") }}
      </p>

      <div class="flex" v-if="availableOfferedMonths">
        <p class="text-primary-dark text-sm pt-2 flex">
          Vos clients bénéficient de {{ this.offeredMonths }} mois offerts par Estaly 🎁
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import SaleService from "@/api/services/sale";
import { formatPrice, formatDuration, isPresent } from "@estaly/ui";
import { toCamelCase } from "@/utils/utils";

export default {
  props: {
    price: String,
    productCategoryValue: String,
    offeredMonths: Number,
    contractType: String,
    productless: { type: Boolean, default: false },
  },

  data: () => {
    return {
      contracts: [],
      monthlyPrice: null,
      productIsInsurable: true,
    };
  },

  computed: {
    ...mapState("store", ["selectedStoreId"]),
    sortedContractsByTermLength() {
      const contracts = this.contracts;
      const monthlyContracts = contracts.filter((contract) => contract.monthly);
      const annualContracts = contracts.filter((contract) => !contract.monthly);

      monthlyContracts.sort((a, b) => a.termLength - b.termLength);
      annualContracts.sort((a, b) => a.termLength - b.termLength);

      return [...annualContracts, ...monthlyContracts];
    },
    availableOfferedMonths() {
      return isPresent(this.offeredMonths);
    },
    productRequired() {
      return !this.productless;
    },
  },

  watch: {
    price() {
      if (this.productRequired && isPresent(this.productCategoryValue) && isPresent(this.price)) {
        this.getContracts();
      } else {
        this.resetAttributes();
      }
    },
    productCategoryValue(newValue) {
      this.resetAttributes();
      if (newValue && (this.productless || isPresent(this.price))) {
        this.getContracts();
      }
    },
  },

  methods: {
    ...mapActions("notifications", ["notify"]),
    isPresent,
    formatPrice,
    formatDuration,

    resetAttributes() {
      this.contracts = [];
      this.monthlyPrice = null;
      this.productIsInsurable = true;
    },

    async getContracts() {
      const response = await SaleService.seeContractDetails(
        isPresent(this.productCategoryValue) ? this.productCategoryValue : "",
        this.price,
        this.selectedStoreId,
      );

      if (!response?.success) return;

      const formattedResponse = toCamelCase(response.data);
      this.contracts = formattedResponse.contracts;
      this.monthlyPrice = formattedResponse.monthlyPriceEquivalent;
      this.productIsInsurable = formattedResponse.productIsInsurable;
    },
  },
};
</script>
